import { CommonModule } from '@angular/common';
import { Component, DestroyRef, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { User } from '@supabase/supabase-js';
import { ButtonModule } from 'primeng/button';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputTextModule } from 'primeng/inputtext';
import { Observable } from 'rxjs';
import { SidebarService } from '../../services/sidebar.service';
import { SupabaseService } from '../../services/supabase.service';
import { ThemeService } from '../../services/theme.service';
import { TranslatePipe } from '@ngx-translate/core';
import { BrandLogoComponent } from '../ui/brand-logo/brand-logo.component';
import { LanguageSwitcherComponent } from '../ui/language-switcher/language-switcher.component';
import { NotificationBellComponent } from '../notifications/notification-bell.component';

@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    ButtonModule,
    RouterModule,
    FloatLabelModule,
    InputGroupModule,
    InputTextModule,
    NotificationBellComponent,
    BrandLogoComponent,
    LanguageSwitcherComponent,
    TranslatePipe,
  ],
  templateUrl: './header.component.html',
  styles: [
    `
      :host {
        display: block;
      }
      /* Header chrome uses the global Apple nav system (.ap-nav* in _apple.scss). */
    `,
  ],
})
export class HeaderComponent implements OnInit {
  @Output() sidebarToggled = new EventEmitter<boolean>();
  user: User | null | undefined = undefined;
  user$!: Observable<User | null | undefined>;
  sidebarOpen = false;
  isLandingPage = false;

  private destroyRef = inject(DestroyRef);

  constructor(
    private sidebarService: SidebarService,
    private supabaseService: SupabaseService,
    private activatedRoute: ActivatedRoute,
    public themeService: ThemeService
  ) {}

  ngOnInit() {
    this.sidebarService.sidebarOpen$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((open) => (this.sidebarOpen = open));
    this.supabaseService.user$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((user) => (this.user = user));

    this.activatedRoute.url
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((route) => {
        this.isLandingPage = route[0].path === '';
      });

    this.user$ = this.supabaseService.user$; // directly assign the observable
  }

  toggleSidebar() {
    this.sidebarService.toggleSidebar();
    this.sidebarToggled.emit(this.sidebarOpen);
  }

  toggleTheme() {
    this.themeService.toggleTheme();
  }

  async signOut() {
    await this.supabaseService.signOut();
  }
}
